import { autoMount } from '../../../utils/autoMount';
import { CompanyTerms } from '../../../components/pages/companyTerms';

autoMount({ CompanyTerms });
